import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetPoiFilters'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetPoiFiltersStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetPoiFiltersStore",
			variables: false,
		})
	}
}

export async function load_GetPoiFilters(params) {
  await initClient()

	const store = new GetPoiFiltersStore()

	await store.fetch(params)

	return {
		GetPoiFilters: store,
	}
}
